'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// this is only true when in a browser-like environment
// (or someone seriously messed up)
exports.default = typeof window !== 'undefined';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/browser.js
// module id = 796
// module chunks = 95 96